// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3RKG5","inputWrap":"CustomTip_inputWrap__2C-1U"};